<template>
    <div class="finish-signup" >
        <h1>{{ $t('verify_your_email') }} </h1>
        <span>{{ $t('weve_sent_an_email_to') }} <a href="#">janedoe@hotmail.com</a></span>
        <p>{{ $t('please_check_your_email') }} </p>
        <p>{{ $t('dont_forget') }} </p>
        <div class="dont_email">
            <span>{{ $t('didnt_receive') }}</span>
            <button>{{ $t('cap_resend_link') }}</button>
        </div>
    </div>
</template>

<script>



export default {
    name: "VerifyEmail",
    components: {},
    props: {
    },

    data() {
        return {}
    }
}
</script>

<style scoped>

</style>
